import Api from "../Api";



const getAll = async (filtros) => {


    let query = []
    if(filtros?.data){
        query.push('data='+filtros.data)
    }
    try {
        const { data } = await Api.get('/dashboard?' + query);
        return data;
    } catch (error) {
        console.log(error)
    }



}


export const DashboardService = {
    getAll,
}